import React from 'react';
import ReactDOM from 'react-dom';
import Provider from 'react-redux/lib/components/Provider';

import App from './containers/App/App.js';
import configureStore from './store.js';
import { PersistGate } from 'redux-persist/lib/integration/react';
import './polyfills.js';
import CssBaseline from '@material-ui/core/CssBaseline';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';

import theme from './theme.js';

function init() {
  // Stop redirect to homepage
  if (!window.location.hash) {
    window.location.hash = '#/';
  }

  const { store, persistor } = configureStore();

  const root = document.getElementById('AppRoot');

  ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <CssBaseline />
        <MuiThemeProvider theme={theme}>
          <App />
        </MuiThemeProvider>
      </PersistGate>
    </Provider>,
    root
  );
}

init();
